window.adev = window.adev || {};

(function ($) {
	"use strict";

	adev = {
		init: function() {
			this.bannerCarousel();
			this.featuredItems();
			this.featuredCollections();
			this.product();
			this.quantitySelector();
			this.accordions();
		},
		bannerCarousel: function(){
			$('[data-adev-banner-carousel]').each(function(e){
				let carousel = $(this);
				
				carousel.not('.slick-initialized').slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: carousel.data('carousel-loop'),
					speed: 500,
					fade: carousel.data('carousel-fade'),
					cssEase: 'linear',
					adaptiveHeight: true,
					prevArrow: '<button type="button" class="slick-prev adev-slick-prev"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 32 32"><path fill="currentColor" d="m19.03 4.28l-11 11l-.686.72l.687.72l11 11l1.44-1.44L10.187 16l10.28-10.28l-1.437-1.44z"/></svg></button>',
					nextArrow: '<button type="button" class="slick-next adev-slick-next"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 32 32"><g transform="rotate(180 16 16)"><path fill="currentColor" d="m19.03 4.28l-11 11l-.686.72l.687.72l11 11l1.44-1.44L10.187 16l10.28-10.28l-1.437-1.44z"/></g></svg></button>',
					dots: false,
					arrows: carousel.data('carousel-arrows'),
					autoplay: carousel.data('carousel-autoplay'),
					autoplaySpeed: parseInt(carousel.data('carousel-autoplay-speed'))
				});
			})
		},
		featuredItems: function(){
			$('[data-adev-featured-items]').on("wheel", function(e){
				e.preventDefault();
				$(this)[0].scrollLeft += e.originalEvent.deltaY > 0 ? 40 : -40;
			});
		},
		featuredCollections: function(){
			$('[data-adev-scrollbar-desktop="true"]').on("wheel", function(e){
				e.preventDefault();
				$(this)[0].scrollLeft += e.originalEvent.deltaY > 0 ? 35 : -35;
			});
		},
		product: function(){
			var self = this

			$(document).on('adev:product:added_to_cart', function(e){
				console.log('adev:product:added_to_cart: ran!');
			})
			
			$(document).on('adev:change:media', function(e, state){
				if(state === undefined) return;
				
				var index = state.index;
				var carousel = state.carousel;
				
				carousel.slick('slickGoTo', index)
			})

			$('[data-main-product-section]').each(function(e){
				var product = $(this);
				var isFeatured = product.data('featured-product') == true;
				self.productMedia(product);
				self.productVariants(product, isFeatured);
				self.productForm(product);
				self.variantSwatches(product)
			})
		},
		productMedia: function(product){
			var selfthis = this

			var options = {
				slidesToShow: 1,
				slidesToScroll: 1,
				adaptiveHeight: true,
				arrows: true,
				dots:true,
				speed: 300,
				prevArrow: '<div class="slick-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><g stroke-width="1.5" fill="none"><path d="M15 6l-6 6l6 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></g></svg></div>',
				nextArrow: '<div class="slick-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><g stroke-width="1.5" fill="none"><path d="M9 6l6 6l-6 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></g></svg></div>'
			};

			if($(window).outerWidth() > 991) {
				options.asNavFor = product.find('[data-product-media-thumbs]')
			}

			product.find('[data-product-media-main]').not('.slick-initialized').slick(options);

			if($(window).outerWidth() > 991) {
				product.find('[data-product-media-thumbs]').not('.slick-initialized').slick({
					slidesToShow: 8,
					slidesToScroll: 1,
					adaptiveHeight: true,
					arrows: false,
					speed: 300,
					asNavFor: product.find('[data-product-media-main]'),
					dots:false,
					focusOnSelect: true
				});
			} else {
				product.find('[data-product-media-thumbs].slick-initialized').slick('unslick')
			}
			
			
			var debounced;
			$(window).on('resize', function(e){
				clearTimeout(debounced)
				debounced = setTimeout(function(){
					selfthis.productMedia(product);
				}, 250)
			})
		},
		productForm: function(product){
			var selfthis = this;
			var whenAddedToCart = product.data('added-to-cart')
			var form = product.find('.product__form'),
			addToCart = product.find('[data-add-to-cart]'),
			buyItNow = product.find('[data-buy-it-now]');

			form.off().on('submit', function(e){
				var clearATC;
				e.preventDefault();
				clearTimeout(clearATC);

				addToCart.prop('disabled', true).addClass('loading');

				var data = $(this).serialize();
				var params = $.param({
					'sections': 'cart-icon-bubble'
				})

				data = data + '&' + params;

				selfthis.ajaxPost(theme.routes.cartAddUrl, data)
				.done(function(resp){
					$(document).trigger('adev:product:added_to_cart', resp);

					if(whenAddedToCart === 'open_cart_drawer') {
						$(document).trigger('adev:cart:drawer:refresh', resp.sections['adev-cart-drawer'])
						$(document).trigger('adev:open:drawer', 'cart-drawer');
					} else if (whenAddedToCart === 'redirect_to_cart') {
						window.location.assign(theme.routes.cartUrl)
					} else if (whenAddedToCart === 'redirect_to_checkout') {
						window.location.assign('/checkout')
					} else {
						window.location.assign('/cart')
					}
					
					
					clearATC = setTimeout(function(){
						addToCart.prop('disabled', false).removeClass('loading').find('span').text(theme.strings.addToCart);
					}, 500);
				})
				.catch(function(XMLHttpRequest, textStatus){
					Shopify.onError(XMLHttpRequest, textStatus);
					addToCart.prop('disabled', false).removeClass('loading').find('span').text(theme.strings.addToCart);
				})

			});

			if(buyItNow.length === 0) return;

			var clearBN;
			buyItNow.on('click', function(e){
				e.preventDefault();
				clearTimeout(clearBN);
				$(this).prop('disabled', true).addClass('loading');
				
				var data = form.serialize();
				var params = $.param({
					'sections': 'adev-cart-drawer'
				})
				data = data + '&' + params;

				selfthis.ajaxPost(theme.routes.cartAddUrl, data)
				.done(function(resp){
					$(document).trigger('adev:cart:drawer:refresh', resp.sections['adev-cart-drawer'])
					window.location.assign('/checkout');
					clearBN = setTimeout(function(){
						buyItNow.prop('disabled', false).removeClass('loading').find('span').text(theme.strings.buyItNow);
					}, 3500);
				})
				.catch(function(XMLHttpRequest, textStatus){
					Shopify.onError(XMLHttpRequest, textStatus);
					buyItNow.prop('disabled', false).removeClass('loading').find('span').text(theme.strings.buyItNow);
				})

			})
		},
		productVariants: function(product, isFeatured = false){
			var select = product.find('select[name="id"]')

			var productJSON = JSON.parse(product.find('[data-product-json]').html()),
			addToCart = product.find('[data-add-to-cart]'),
			buyItNow = product.find('[data-buy-it-now]'),
			prices = product.find('[data-product-prices]'),
			regularPrice = product.find('[data-regular-price]'),
			compareAtPrice = product.find('[data-compare-at-price]');

			new Shopify.OptionSelectors(select.attr('id'), {
				product: productJSON,
				onVariantSelected: function(variant){
					prices.attr('data-available', variant.available === true ? 'true' : 'false')

					if (variant) {

						if (variant.available) {
							addToCart.removeClass('disabled').prop('disabled', false).find('span').text(theme.strings.addToCart);
							buyItNow.removeClass('disabled').prop('disabled', false).find('span').text(theme.strings.buyItNow);
						} else {
							addToCart.addClass('disabled').prop('disabled', true).find('span').text(theme.strings.soldOut)
							buyItNow.addClass('disabled').prop('disabled', true).find('span').text(theme.strings.soldOut)
						}

						if (variant.compare_at_price > variant.price) {
							regularPrice.html(Shopify.formatMoney(variant.price, ''));
							compareAtPrice.show().find('s').html(Shopify.formatMoney(variant.compare_at_price, ''));
							prices.attr('data-on-sale', 'true')
						} else {
							regularPrice.html(Shopify.formatMoney(variant.price, ''));
							compareAtPrice.hide().find('s').empty();
							prices.attr('data-on-sale', 'false')
						}

					  	if(variant.featured_image !== null) {
							var imageId = variant.featured_media.id;
							var slideIndex = $('.product-single__media[data-image-id="'+ imageId +'"]').data('index') - 1
							
							$(document).trigger('adev:change:media', {
								index: slideIndex,
								carousel: product.find('[data-product-media-main].slick-initialized')
							})
						}
					} else {
						addToCart.addClass('disabled').prop('disabled', true).find('span').text(theme.strings.unavailable);
						buyItNow.addClass('disabled').prop('disabled', true).find('span').text(theme.strings.unavailable);
					}
					
					
					$(document).trigger('adev:variant:changed', variant);
				},
				enableHistoryState: isFeatured === true ? false : true
			});
		},
		variantSwatches: function(product){
			product.find('[data-adev-swatch-option]').each(function(e){
				var option = $(this);
				var selectedValue = option.find('[data-selected-value]')
				var swatchesInputs = option.find('[data-variant-option-input]');

				swatchesInputs.each(function(e){
					var input = $(this);
	
					input.on('change', function(e){
						var changed = $(this)
						var index = changed.data('index')
						var value = changed.val()
						selectedValue.text(value)
	
						if(product.find('.single-option-selector').length) {
							product.find('.single-option-selector[data-option="option'+ index +'"]').val(value).trigger('change')
						}
					})
	
				})
			})
		},
		quantitySelector: function(){
			$('[data-quantity-selector]').each(function() {

				var self = $(this)
		
				var spinner = self.find('[data-quantity-value]');
				var spinnerMin = spinner.attr('min') || 1;
				var spinnerMax = spinner.attr('max') || 1000;
		
				var up = self.find('[data-quantity-up]');
				var down = self.find('[data-quantity-down]');
		
				up.off().on('click', function(e) {
					e.preventDefault();
						var value = parseInt(spinner.val(), 10);
						value = isNaN(value) ? 0 : value;
						value++;
						if (spinnerMax >= value) {
							spinner.attr('value', value).val(value).trigger('change');
							self.trigger('adev:quantity:change', value);
						}
				});
				down.off().on('click', function(e) {
					e.preventDefault();
					var value = parseInt(spinner.val(), 10);
					value = isNaN(value) ? 0 : value;
					if (value !== 0) {
						value--;
						if (spinnerMin <= value) {
							spinner.attr('value', value).val(value).trigger('change');
							self.trigger('adev:quantity:change', value);
						}
					}
				});
			});
		},
		accordions: function(){
			$('[data-accordions]').each(function(e){
				var isFree = $(this).data('accordions') === true;

				$(this).find('[data-accordion-item]').each(function(){
					var self = $(this);
					var open = self.children('[data-accordion-title]')
					var content = self.children('[data-accordion-content]')
					open.on('click', function(e){
						e.preventDefault()
						
						if(isFree && !self.hasClass('active')) {
							$('[data-accordion-item].active [data-accordion-content]').slideToggle()
							$('[data-accordion-item].active').removeClass('active')
						}

						self.toggleClass('active')
						content.slideToggle();
					})
				})	
			})
		},
		ajaxGet: function(url){
			return $.ajax({
				url: url,
				type: 'GET',
			});
		},
		ajaxPost: function(url, data, dataType = 'json'){
			return $.ajax({
				url: url,
				type: 'POST',
				data: data,
				dataType: dataType,
			})
		}
	}

	adev.init();

}(jQuery));